import '.ag{position:relative;}.ssr-plugin'
import '.jb{width:64px;}.ssr-plugin'
import '.jc{height:64px;}.ssr-plugin'
import '.ak{flex-shrink:0;}.ssr-plugin'
import '.bm{position:absolute;}.ssr-plugin'
import '.jd{bottom:-4px;}.ssr-plugin'
import '.hg{right:-4px;}.ssr-plugin'
import '.fu{border-radius:50%;}.ssr-plugin'
import '.cw{border:2px solid var(--palette-white);}.ssr-plugin'
import '.bd{overflow:hidden;}.ssr-plugin'
import '.je{width:32px;}.ssr-plugin'
import '.jf{height:32px;}.ssr-plugin'
import { styled } from 'inlines'
import { Avatar } from '@app/components/core/avatar/Avatar'
import { Image } from '@app/components/core/image/Image'
import { StoredImage } from '@app/types/StoredImage'

type ConversationAvatarProps = {
  initiativeImage?: StoredImage
  userAvatar?: string
  userName: string
}

export const ConversationAvatar = ({
  initiativeImage,
  userAvatar,
  userName,
}: ConversationAvatarProps) => {
  const hasImage = !!initiativeImage && !!initiativeImage.src
  return (
    <div className="ag jb jc ak"
    >
      {hasImage ? (
        <Image
          src={initiativeImage.src}
          alt={initiativeImage.altText || 'initiative image'}
          resizeWidth={128}
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            borderRadius: '12px',
          }}
        />
      ) : (
        <Avatar
          size="medium"
          shape="square"
          labelSource={userName}
          variant="yellow"
        />
      )}
      <div className="bm jd hg fu cw bd je jf"
      >
        <Avatar
          size="extra-small"
          shape="circle"
          image={userAvatar}
          labelSource={userName}
        />
      </div>
    </div>
  )
}
